export default function loadCss(href){
    let link = document.createElement("link")
    link.href = href
    link.rel = "Stylesheet"
    link.type = "text/css"

    document.head.appendChild(link)
}